import { IncomingHttpHeaders } from 'http'
import { Cookies } from '@/core/graphQlCookieManager'
import useDevice from 'hooks/useDevice'
import { useCookie } from 'next-cookie'

type MhubSessionData = {
  application: string
  deviceType: string
  env: string
  ip: string
  machine: string
  serverTime: number
  bot_traffic?: BotTraffic
}

export type BotTraffic = {
  is_bot?: string
  bot_category?: string
}

type MhubSession = {
  session: MhubSessionData
}

const internalIps = [
  '78.141.75.228',
  '127.0.0.1',
  '172.20.0.2',
  '90.176.14.147',
  '62.197.213.27',
  '195.98.27.197',
  '213.81.168.98',
  '172.20.0.1',
  '90.176.14.147'
]

export const useMhubSession = (
  ip: string,
  serverTime: number,
  botTraffic: BotTraffic | null
): {
  getSession: () => MhubSession
} => {
  const { isTablet, isDesktop } = useDevice()

  const getSession = (): MhubSession => ({
    session: {
      application: 'react.1.0',
      deviceType: isDesktop ? 'desktop' : isTablet ? 'tablet' : 'mobile',
      env: process.env.NODE_ENV === 'development' ? 'dev' : 'prod',
      ip,
      machine: getMachineTraffic(ip),
      serverTime,
      ...(botTraffic && { bot_traffic: botTraffic })
    }
  })

  return {
    getSession
  }
}

const getMachineTraffic = (ip: string) => {
  const loginSubscriberCookie = !!useCookie().get<string>(
    Cookies.factcoolAdminUser
  )
  return internalIps.includes(ip) || loginSubscriberCookie
    ? 'internal'
    : 'external'
}

const getHeaderValue = (
  headers: IncomingHttpHeaders,
  name: string
): string | null => {
  const raw = headers?.[name]
  const value = (Array.isArray(raw) ? raw[0] : raw)?.trim()
  return value ? value : null
}

// Cloudflare bot detection headers (X-Known-Bot, X-Bot-Category). Missing values are left out,
// when both are missing the whole bot_traffic object is left out of the mhub session.
export const getBotTraffic = (
  headers: IncomingHttpHeaders
): BotTraffic | null => {
  const isBot = getHeaderValue(headers, 'x-known-bot')?.toLowerCase()
  const botCategory = getHeaderValue(headers, 'x-bot-category')
  const botTraffic: BotTraffic = {
    ...((isBot === 'true' || isBot === 'false') && { is_bot: isBot }),
    ...(botCategory && { bot_category: botCategory })
  }
  return Object.keys(botTraffic).length > 0 ? botTraffic : null
}
